<template lang="pug">
  dv-form(
    ref="form"
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-sheet.d-flex.gap-16(
      color="transparent"
      width="100%"
    )
      .d-flex(
        v-if="$slots.prepend"
        style="margin-top: 46px;"
      )
        slot(name="prepend")
      v-row.flex-grow-1
        v-col.flex-grow-1(cols="auto")
          dv-form-field(
            :field="fields.name"
          )
        v-col(
          v-if="withScore"
          cols="4"
        )
          dv-form-field(
            :field="fields.score"
          )
      .d-flex(style="margin-top: 46px;")
        dv-btn.ui-neutral.lighten-4.mt-n3(
          icon
          large
          :disabled="!canDelete"
          @click="$emit('delete')"
        )
          v-icon(color="ui-error") $ui-delete
</template>

<script>
import DvNumberField from '@/packages/ui/components/inputs/DvNumberField.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvFormField,
    DvForm,
    DvBtn,
  },
  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },
    withScore: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    schema() {
      return [
        {
          name: 'name',
          value: 'name',
          label: 'Ответ',
          rules: 'required_fill',
          component: DvTextField,
          props: {
            clearable: true,
          },
        },
        {
          name: 'score',
          value: 'score',
          label: 'Вес ответа в баллах',
          rules: 'required_fill',
          component: DvNumberField,
          props: {
            min: 0,
            max: 999,
            placeholder: undefined,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
        this.$refs.form.reset(val);
      },
      deep: true,
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
